module.exports = __webpack_public_path__ + "static/media/card_bg_5.61f30add.png";